
import React from 'react';
import ScopeOfApplication from './general/ScopeOfApplication';
import Definitions from './general/Definitions';
import DataController from './general/DataController';
import DataProtectionOfficer from './general/DataProtectionOfficer';
import LegalBasis from './general/LegalBasis';
import DataDeletion from './general/DataDeletion';
import DataSecurity from './general/DataSecurity';
import ProcessorCollaboration from './general/ProcessorCollaboration';
import ThirdPartyTransfer from './general/ThirdPartyTransfer';
import AutomatedDecisionMaking from './general/AutomatedDecisionMaking';
import DataProvisionObligation from './general/DataProvisionObligation';
import LegalTransmissionObligation from './general/LegalTransmissionObligation';
import UserRights from './general/UserRights';

const GeneralSection = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4">A. General</h2>
      <div className="space-y-6">
        <ScopeOfApplication />
        <Definitions />
        <DataController />
        <DataProtectionOfficer />
        <LegalBasis />
        <DataDeletion />
        <DataSecurity />
        <ProcessorCollaboration />
        <ThirdPartyTransfer />
        <AutomatedDecisionMaking />
        <DataProvisionObligation />
        <LegalTransmissionObligation />
        <UserRights />
      </div>
    </section>
  );
};

export default GeneralSection;
